import { useRouter } from 'next/router'
import {
    useChangeRouterQuery,
    useOnRouteChangeComplete,
    useOnRouteChangeStart,
    useRouteInitPath
} from '@entities/route/model'
import { useEffect } from 'react'
import { attachRouter } from 'src/infastruct/effector-utils/attach-router'
import { useEvent } from 'effector-react'
import { useAddHistoryPath } from 'src/features/history-paths/hooks'

export const useRouterSubscriber = () => {
    const router = useRouter()
    const onRouteChangeComplete = useOnRouteChangeComplete()
    const onRouteChangeStart = useOnRouteChangeStart()
    //const changeRouter = useChangeRouterQuery()
    const routeInitPath = useRouteInitPath()
    const attachRouterEvent = useEvent(attachRouter)
    const addHistoryPath = useAddHistoryPath()
    useEffect(() => {
        router.events.on('routeChangeComplete', onRouteChangeComplete)
        router.events.on('routeChangeError', onRouteChangeComplete)
        router.events.on('routeChangeStart', onRouteChangeStart)
        routeInitPath(router.asPath)

        return () => {
            router.events.off('routeChangeComplete', onRouteChangeComplete)
            router.events.off('routeChangeStart', onRouteChangeStart)
            router.events.off('routeChangeError', onRouteChangeComplete)
        }
    }, [])

    //useEffect(() => {}, [router.query])

    useEffect(() => {
        addHistoryPath(router.asPath)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath])

    useEffect(() => {
        attachRouterEvent(router)
        return () => {
            attachRouterEvent(null)
        }
    }, [router, attachRouterEvent])
}
